import axios from "axios";

class PaycontrolService {
    baseUrl = "/personal/api/v1"
    qrImageUrl = `/paycontrol/qr.png`
    qrUrl = `/paycontrol/qr`
    get(url) {
        let totalUrl = `${this.baseUrl}${url}`
        return axios.get(totalUrl, {withCredentials: true})
    }

    getQrImage() {
      return this.get(this.qrImageUrl)
    }
    getQr() {
      return this.get(this.qrUrl)
    }
    getSettings(){
        return this.get(`/paycontrol/settings`)
    }    
    getState(){
      return this.get('/paycontrol/clientstate')      
    }
    disconnect() {
        return axios.post(`${this.baseUrl}/paycontrol/disconnect`, {withCredentials: true})
    }
}

export default new PaycontrolService()
